var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('img',{staticClass:"loading-image",attrs:{"src":"https://code.jquery.com/mobile/1.4.2/images/ajax-loader.gif"}}),_c('span',{staticClass:"loading-text"},[_vm._v("LOADING...")])])
}]

export { render, staticRenderFns }